import React from "react";
import {
  FiCamera,
  FiEye,
  FiEyeOff,
  FiMail,
  FiUser,
  FiUsers,
} from "react-icons/fi";

const statCards = [
  {
    key: "total",
    label: "Profils au total",
    helper: "Tous profils confondus",
    icon: FiUsers,
    valueKey: "total",
    className:
      "from-indigo-50 to-sky-50 text-indigo-700 dark:from-indigo-500/10 dark:to-sky-500/10 dark:text-indigo-300",
  },
  {
    key: "elected",
    label: "Élus",
    helper: "Sur la page actuelle",
    icon: FiUsers,
    valueKey: "electedOnPage",
    className:
      "from-amber-50 to-orange-50 text-amber-700 dark:from-amber-500/10 dark:to-orange-500/10 dark:text-amber-300",
  },
  {
    key: "personnel",
    label: "Personnel",
    helper: "Sur la page actuelle",
    icon: FiUser,
    valueKey: "personnelOnPage",
    className:
      "from-sky-50 to-cyan-50 text-sky-700 dark:from-sky-500/10 dark:to-cyan-500/10 dark:text-sky-300",
  },
  {
    key: "visible",
    label: "Visibles",
    helper: "Affichés côté public",
    icon: FiEye,
    valueKey: "visibleOnPage",
    className:
      "from-emerald-50 to-teal-50 text-emerald-700 dark:from-emerald-500/10 dark:to-teal-500/10 dark:text-emerald-300",
  },
  {
    key: "hidden",
    label: "Masqués",
    helper: "Non affichés",
    icon: FiEyeOff,
    valueKey: "hiddenOnPage",
    className:
      "from-slate-50 to-zinc-50 text-slate-700 dark:from-slate-500/10 dark:to-zinc-500/10 dark:text-slate-300",
  },
  {
    key: "photo",
    label: "Avec photo",
    helper: "Portrait renseigné",
    icon: FiCamera,
    valueKey: "withPhotoOnPage",
    className:
      "from-rose-50 to-pink-50 text-rose-700 dark:from-rose-500/10 dark:to-pink-500/10 dark:text-rose-300",
  },
];

export default function TrombinosStatsGrid({ stats, loading }) {
  return (
    <section className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6">
      {statCards.map((card) => {
        const Icon = card.icon;

        return (
          <article
            key={card.key}
            className={`rounded-[1.7rem] border border-white/70 bg-gradient-to-br p-5 shadow-sm dark:border-white/10 ${card.className}`}
          >
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="text-xs font-bold uppercase tracking-[0.18em] opacity-70">
                  {card.label}
                </p>

                <p className="mt-3 text-3xl font-bold">
                  {loading ? "…" : stats[card.valueKey]}
                </p>

                <p className="mt-1 text-sm font-medium opacity-70">
                  {card.helper}
                </p>
              </div>

              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-white/70 text-xl shadow-sm dark:bg-white/10">
                <Icon />
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
}